module.exports = __webpack_public_path__ + "img/badge-founder.427f27da.png";